var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130px",
    height: "101px",
    viewBox: "0 0 130 101",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "25A04A2C-2AE3-4BC7-B5F3-0A015978EA10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Form",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_Form-press",
    transform: "translate(-152.000000, -129.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "computer-01-01",
    transform: "translate(216.750000, 179.500000) rotate(-13.000000) translate(-216.750000, -179.500000) translate(159.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.76,63.51 L110.37,63.51 L110.37,6.83 C110.37,3.06 107.31,0 103.54,0 L11.97,0 C8.2,0 5.14,3.06 5.14,6.83 L5.14,63.51 L0.75,63.51 C0.34,63.51 0,63.85 0,64.26 L0,66.36 C0,71.13 3.87,74.99 8.64,75 L106.86,75 C111.63,75 115.49,71.13 115.5,66.36 L115.5,64.26 C115.5,63.85 115.16,63.51 114.75,63.51 L114.76,63.51 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64,6.84 C6.64,3.9 9.03,1.51 11.97,1.51 L103.54,1.51 C106.48,1.51 108.87,3.9 108.87,6.84 L108.87,63.52 L104.15,63.52 L104.15,6.99 C104.15,6.58 103.81,6.24 103.4,6.24 L12.11,6.24 C11.7,6.24 11.36,6.58 11.36,6.99 L11.36,63.52 L6.64,63.52 L6.64,6.84 L6.64,6.84 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 12.86,
    y: 7.74,
    width: 89.79,
    height: 55.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3,65.01 L66.2,65.01 L66.2,65.72 C66.2,67.66 64.63,69.23 62.69,69.23 L52.81,69.23 C50.87,69.23 49.3,67.66 49.3,65.72 L49.3,65.01 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,66.37 C114,70.31 110.8,73.51 106.86,73.51 L8.64,73.51 C4.7,73.51 1.5,70.31 1.5,66.37 L1.5,65.02 L47.8,65.02 L47.8,65.73 C47.8,68.49 50.04,70.74 52.81,70.74 L62.7,70.74 C65.46,70.74 67.71,68.5 67.71,65.73 L67.71,65.02 L114.01,65.02 L114.01,66.37 L114,66.37 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.76,63.51 L110.37,63.51 L110.37,6.83 C110.37,3.06 107.31,0 103.54,0 L11.97,0 C8.2,0 5.14,3.06 5.14,6.83 L5.14,63.51 L0.75,63.51 C0.34,63.51 0,63.85 0,64.26 L0,66.36 C0,71.13 3.87,74.99 8.64,75 L106.86,75 C111.63,75 115.49,71.13 115.5,66.36 L115.5,64.26 C115.5,63.85 115.16,63.51 114.75,63.51 L114.76,63.51 Z M6.65,6.83 C6.65,3.89 9.04,1.5 11.98,1.5 L103.55,1.5 C106.49,1.5 108.88,3.89 108.88,6.83 L108.88,63.51 L104.16,63.51 L104.16,6.98 C104.16,6.57 103.82,6.23 103.41,6.23 L12.12,6.23 C11.71,6.23 11.37,6.57 11.37,6.98 L11.37,63.51 L6.65,63.51 L6.65,6.83 L6.65,6.83 Z M12.87,63.51 L12.87,7.73 L102.66,7.73 L102.66,63.51 L12.87,63.51 L12.87,63.51 Z M49.31,65.01 L66.21,65.01 L66.21,65.72 C66.21,67.66 64.64,69.23 62.7,69.23 L52.82,69.23 C50.88,69.23 49.31,67.66 49.31,65.72 L49.31,65.01 Z M114.01,66.36 C114.01,70.3 110.81,73.5 106.87,73.5 L8.65,73.5 C4.71,73.5 1.51,70.3 1.51,66.36 L1.51,65.01 L47.81,65.01 L47.81,65.72 C47.81,68.48 50.05,70.73 52.82,70.73 L62.71,70.73 C65.47,70.73 67.72,68.49 67.72,65.72 L67.72,65.01 L114.02,65.01 L114.02,66.36 L114.01,66.36 Z",
    id: "Shape",
    fill: "#3669C9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.681d70e9e50c15fdc65bf6cb5c4de751.svg";
export { ForwardRef as ReactComponent };